import React, { useEffect, useState } from 'react'
import { Avatar, Spin } from 'antd';
import { useSelector } from 'react-redux';
import useBookingApi from '../../../../../config/hooks/api/booking/useBookingApi';
import { LoadingOutlined } from '@ant-design/icons';

const ReviewResponse = ({ replyData }) => {
    const { loggedInUser } = useSelector((state) => state?.auth)
    const { getServiceProviderDetailById } = useBookingApi()

    const [spData, setSpData] = useState(null)
    const [loading, setLoading] = useState(false)

    const getSPDetailsById = async () => {
        try {
            setLoading(true)
            if (!loggedInUser) return null

            const response = await getServiceProviderDetailById(replyData?.providerId)

            if (response) {
                setSpData(response?.data?.serviceProvider)

                setLoading(false)
            }
        } catch (error) {
            console.log(error)
            setLoading(false)
        }
    }

    useEffect(() => {
        if(replyData?.providerId){
            getSPDetailsById()
        }
    }, [])


    return (
        <div className='flex items-center mb-1'>
            { loading ? (
                <Spin indicator={<LoadingOutlined className='text-black' spin />} size="small" />
            ) : (
                <React.Fragment>
                    <div className='h-[35px] mr-3'>
                        <Avatar
                            src={spData?.imageThumbUrl}
                            className='w-full h-full aspect-square object-cover'
                            size={'small'}
                        />
                    </div>
                    <div>
                        <div className='flex sm:flex-row flex-col sm:items-end mb-[2px]'>
                            <p className='text-md font-semibold mr-2'>
                                {spData?.fullName && spData?.fullName.length > 10 ? 
                                spData?.fullName.slice(0,10)+'...' : spData?.fullName}
                            </p>
                            {/* <p className='text-xs mb-[3px]'>{getCustomormattedDateTime(review?.createdAt)}</p> */}
                        </div>
                        <div className='flex flex-col'>
                            <div className='sm:order-1 order-2'>
                                <p className='text-xs'>{replyData?.reply}</p>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            )}
        </div>
    )
}

export default ReviewResponse